import { Box } from '@mui/material';
import MediaEntetiesTable from '../../../common/MediaEntitiesTable';

const EitaTable = () => {
	return (
		<Box className="w-full">
			<MediaEntetiesTable media_id={4} />
		</Box>
	);
};

export default EitaTable;
